var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfindemnityforcompaniesicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 75,
    viewBox: "0 0 77 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8216 2.19961L46.3047 6.20218C45.4711 6.29196 44.7471 5.99709 44.1243 5.34307L46.4776 2.06445L46.8216 2.19961Z",
    fill: "#FFD2A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2641 6.30558L39.4819 23.5086L38.7532 23.2213L45.5353 6.01825C45.8104 5.32075 46.5391 5.60808 46.2641 6.30558Z",
    fill: "#005B6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5352 6.01792L38.7531 23.221L38.0234 22.9337L44.8066 5.73062C45.074 5.05013 45.8027 5.33744 45.5352 6.01792Z",
    fill: "#005B6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8058 5.72983L38.0227 22.9329L37.2939 22.6456L44.0761 5.44253C44.3313 4.79606 45.061 5.08337 44.8058 5.72983Z",
    fill: "#005B6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9444 0.921422L46.4868 2.08203L46.8095 2.20926L47.2671 1.04865L46.9444 0.921422Z",
    fill: "#3C3C3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2062 2.37051L6.04297 6.28711L11.1583 46.9881L42.3215 43.0715L37.2062 2.37051Z",
    fill: "#C6C6C6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2587 41.7509C39.4912 41.6866 39.6339 41.4711 39.5791 41.2698L28.2443 0.266753C28.1886 0.0654424 27.9551 -0.0460822 27.7226 0.0181859L0.332128 7.59048C0.0996285 7.65474 -0.0431032 7.87023 0.0117137 8.07154L11.3465 49.0756C11.4023 49.2769 11.6357 49.3884 11.8682 49.3241L39.2587 41.7509Z",
    fill: "#EDEDED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4255 16.695L21.38 11.4826L19.7837 5.70703C18.3045 6.1673 17.0759 7.15778 16.3075 8.51213C15.507 9.92414 15.3038 11.5639 15.7366 13.1291C16.1525 14.628 17.1033 15.8879 18.4255 16.695Z",
    fill: "#FFB100"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1711 5.59954L21.7362 11.2617L27.3984 9.69666C26.9372 8.21754 25.9477 6.98793 24.5933 6.2205C23.2399 5.45306 21.6767 5.23567 20.1711 5.59954Z",
    fill: "#575756"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1172 11.5735L25.5395 13.5138L26.9808 14.3304C27.6698 13.0176 27.8541 11.5243 27.5063 10.084L22.1172 11.5735Z",
    fill: "#E63F12"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6719 11.7812L18.7751 16.8915C20.1465 17.6117 21.7154 17.7809 23.2163 17.366C24.7162 16.951 25.976 16.0002 26.7832 14.678L21.6719 11.7812Z",
    fill: "#005B6B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2202 17.502L26.5684 18.5117L29.9762 30.8363L33.628 29.8265L30.2202 17.502Z",
    fill: "#005B6B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0749 21.0473L22.4231 22.0566L25.2199 32.175L28.8717 31.1656L26.0749 21.0473Z",
    fill: "#005B6B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4704 26.3891L18.8186 27.3984L20.499 33.4778L24.1508 32.4684L22.4704 26.3891Z",
    fill: "#005B6B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.167 25.4355L13.5151 26.4453L15.8122 34.7528L19.4641 33.743L17.167 25.4355Z",
    fill: "#005B6B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7392 24.3441L8.0874 25.3535L11.0546 36.0885L14.7065 35.0792L11.7392 24.3441Z",
    fill: "#005B6B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36872 16.6886L11.9141 21.4221L13.7411 15.1186L12.2701 15.481L10.4274 8.00245L6.9359 8.86227L8.77778 16.3413L7.36872 16.6886Z",
    fill: "#E63F12"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2675 32.1331L11.729 38.3652L11.9683 39.2306L34.5068 32.9985L34.2675 32.1331Z",
    fill: "#575756"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7759 34.1413L12.2373 40.3711L12.4765 41.2365L35.0151 35.0067L34.7759 34.1413Z",
    fill: "#575756"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.321 36.114L12.7825 42.3438L13.0217 43.2091L35.5602 36.9793L35.321 36.114Z",
    fill: "#575756"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8664 38.0847L13.3279 44.3145L13.5671 45.1798L36.1056 38.95L35.8664 38.0847Z",
    fill: "#575756"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5246 65.3965C19.0077 65.3965 17.7856 64.165 17.7856 62.6481V35.0176C17.7856 33.6027 18.8442 32.4317 20.2184 32.2682C20.3299 32.2578 20.432 32.2578 20.5237 32.2578H62.2611C62.3528 32.2578 62.4548 32.2578 62.5664 32.2682C63.9406 32.4308 65 33.6018 65 35.0176V62.6481C65 64.165 63.778 65.3965 62.2611 65.3965H20.5246Z",
    fill: "#3C3C3B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2186 49.6886C28.8577 49.6886 26.5979 48.7398 24.9468 47.0518C21.6994 43.7316 17.7847 39.6902 17.7847 39.6902V35.0176C17.7847 33.6027 18.8432 32.4317 20.2174 32.2682C20.3289 32.2578 20.431 32.2578 20.5227 32.2578H62.2601C62.3518 32.2578 62.4539 32.2578 62.5654 32.2682C63.9396 32.4308 64.9991 33.6018 64.9991 35.0176V39.6902C64.9991 39.6902 61.0844 43.7316 57.8379 47.0518C56.1868 48.7398 53.927 49.6886 51.5661 49.6886H31.2186Z",
    fill: "#575756"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M40.406 54.4588C39.7133 54.4588 39.1519 53.8974 39.1519 53.2037V45.5586H43.6355V53.2037C43.6355 53.8964 43.0741 54.4588 42.3804 54.4588H40.406Z",
    fill: "#B3B3B3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9692 49.9414H38.8164V51.085H43.9692V49.9414Z",
    fill: "#999999"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1473 48.8316C37.6672 48.8316 37.2769 48.4421 37.2769 47.9611V46.4281C37.2769 45.948 37.6662 45.5586 38.1473 45.5586H44.6384C45.1185 45.5586 45.5079 45.948 45.5079 46.4281V47.9611C45.5079 48.4412 45.1185 48.8316 44.6384 48.8316H38.1473Z",
    fill: "#999999"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3788 53.9232C39.9875 53.9232 39.6699 53.6056 39.6699 53.2144V51.0859H43.1158V53.2144C43.1158 53.6056 42.7983 53.9232 42.407 53.9232H40.3788Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2011 47.2472C39.2011 47.5525 38.9535 47.7992 38.6491 47.7992C38.3448 47.7992 38.0972 47.5525 38.0972 47.2472C38.0972 46.942 38.3448 46.6953 38.6491 46.6953C38.9535 46.6953 39.2011 46.9429 39.2011 47.2472Z",
    fill: "#4D4D4D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5845 47.2472C43.5845 47.5525 43.8312 47.7992 44.1364 47.7992C44.4417 47.7992 44.6884 47.5525 44.6884 47.2472C44.6884 46.942 44.4417 46.6953 44.1364 46.6953C43.8312 46.6953 43.5845 46.9429 43.5845 47.2472Z",
    fill: "#4D4D4D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3389 51.8658C40.2142 51.8658 40.113 51.7647 40.113 51.6399C40.113 51.5152 40.2142 51.4141 40.3389 51.4141H42.4466C42.5713 51.4141 42.6724 51.5152 42.6724 51.6399C42.6724 51.7647 42.5713 51.8658 42.4466 51.8658H40.3389Z",
    fill: "#999999"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3389 52.7311C40.2142 52.7311 40.113 52.6299 40.113 52.5052C40.113 52.3804 40.2142 52.2793 40.3389 52.2793H42.4466C42.5713 52.2793 42.6724 52.3804 42.6724 52.5052C42.6724 52.6299 42.5713 52.7311 42.4466 52.7311H40.3389Z",
    fill: "#999999"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3389 53.5943C40.2142 53.5943 40.113 53.4932 40.113 53.3685C40.113 53.2437 40.2142 53.1426 40.3389 53.1426H42.4466C42.5713 53.1426 42.6724 53.2437 42.6724 53.3685C42.6724 53.4932 42.5713 53.5943 42.4466 53.5943H40.3389Z",
    fill: "#999999"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3929 30.1092C39.702 30.1092 38.0103 30.5733 36.5217 31.5023C36.0898 31.7698 35.5209 31.7358 35.2241 31.3681C34.9283 31.0024 35.0908 30.3823 35.6192 30.0534C37.3837 28.9524 39.3883 28.4023 41.3929 28.4023C43.3975 28.4023 45.4021 28.9524 47.1666 30.0534C47.6949 30.3823 47.8575 31.0024 47.5617 31.3681C47.2658 31.7358 46.6969 31.7698 46.264 31.5023C44.7755 30.5742 43.0846 30.1092 41.3929 30.1092Z",
    fill: "#3C3C3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfindemnityforcompaniesicon);
export default __webpack_public_path__ + "static/media/prof indemnity for companies icon.b76b8a2aade8d53044cb21e3ce9d9b11.svg";
export { ForwardRef as ReactComponent };